import { GenealogyNode } from "@common/components/Diagram/Genealogy/component";
import { type GenealogyItem } from "@common/components/Diagram/Genealogy/lib";
import { Basicprimitives } from "@common/controls/Diagram/Basicprimitives/types";
import Icon from "@common/controls/Icon/component";
import { type GenericMap, IconType } from "@common/declarations";
import { identity } from "lodash";
import React from "react";
import { type DiagramConfig } from "./component";

type TemplateDescription<T extends Basicprimitives.OrgItemConfig> = {
  mapItem: (item: any, onClick: (item: T) => void) => T;
  onItemRender: Basicprimitives.OnItemRender<T>;
};
const TEMPLATES: GenericMap<TemplateDescription<any>> = {
  genealogy: {
    mapItem: (item: any): GenealogyItem => ({
      color: item.CommissionPercentage ? item.PinRankColor : "#ddd",
      commissionPercentage: item.CommissionPercentage,
      email: item.Email,
      firstName: item.FirstName,
      hasButtons: item.UserID ? Basicprimitives.Enabled.True : Basicprimitives.Enabled.False,
      id: item.ID,
      instance: item.Instance,
      isDeleted: item.IsDeleted,
      itemTitleColor: item.CommissionPercentage ? item.PinRankColor : "#ddd",
      lastName: item.LastName,
      level: item.level,
      noHighlight: item.IsDeleted,
      parent: item.ParentID,
      pinRankColor: item.PinRankColor,
      pinRankName: item.PinRankName,
      placedOnDate: item.PlacedOnDate,
      rankColor: item.RankColor,
      rankName: item.RankName,
      statusName: item.StatusName,
      telephone: item.Telephone,
      templateName: "genealogy",
      userId: item.UserID,
      userProfilePictureMediaSourceId: item.UserProfilePictureMediaSourceID,
      userProfilePictureMediaSourceKey: item.UserProfilePictureMediaSourceKey
    }),
    onItemRender: ({ context }) => <GenealogyNode data={context} />
  } as TemplateDescription<GenealogyItem>
};

const getFirstRootId = (items: any[]): string | null => {
  for (const item of items) {
    const mapped = TEMPLATES[item.TemplateName].mapItem(item, identity);
    if (!mapped.parent) return mapped.id;
  }
  return null;
};

export const getConfig = (
  config: DiagramConfig,
  items: any[],
  onItemClick: (item: any) => void
): Basicprimitives.OrgDiagramConfig<any> => {
  return {
    ...config,
    linesColor: "var(--diagramLinesColor)",
    cursorItem: config.cursorItem ?? getFirstRootId(items),
    items: items.map((x) => {
      const t = TEMPLATES[x.TemplateName];
      return t ? t.mapItem(x, onItemClick) : x;
    }),
    onButtonsRender: ({ context }) => (
      <Icon className="settings" icon={IconType.Cog} onClick={(e) => (e.stopPropagation(), onItemClick(context))} />
    ),
    templates: (config.templates || []).map((x) => {
      const t = TEMPLATES[x.name];
      return t
        ? {
            ...x,
            onItemRender: t.onItemRender,
            onCursorRender: () => null,
            onHighlightRender: () => null
          }
        : x;
    })
  };
};
